import React from 'react'
import { StaticDataProvider, useStaticData } from '@mc/static-data-react'
import type { SessionCampLandingPageData } from '../index.page'

export const useSessionsLandingPageData = () =>
  useStaticData<SessionCampLandingPageData>()

export const SessionCampLandingPageDataProvider = ({
  data,
  children,
}: {
  data: SessionCampLandingPageData
  children: React.ReactNode
}) => <StaticDataProvider value={data}>{children}</StaticDataProvider>
